/**
 * Type de relations
 */
export enum RelationType {
    // Pour la page tableau de bord budgétaire
    GENERAL,
    // POur la page admission en non-valeur
    PRICE,
    // Pour la page créances éteintes
    REQUEST,
    // Pour la liste des impayés
    BILLS,
    METERS,
}

/**
 * DTO des demandes des abonnés
 */
export interface RelationRequestsCountDto {
    moveInCount: number;
    moveOutCount: number;
    waterQualityCount: number;
}

/**
 * DTO pour la table des demandes
 * */
export interface RelationRequestsTableDto {
    city: string;
    moveInCount: string;
    moveOutCount: string;
    waterQualityCount: string;
}

/**
 * DTO des demandes des abonnés par communes
 */
export interface RelationRequestsByTownDto {
    city: string;
    requestsCount: RelationRequestsCountDto;
}

/**
 * DTO des indicators demandes
 */
export interface RelationRequestsByTownDto {
    city: string;
    requestsCount: RelationRequestsCountDto;
}

/**
 * DTO des indicators factures
 */
export interface RelationIndicatorsBillsDto {
    city: string;
    theoricNumberOfBills: string;
    facturationMonth: string;
    billsValidationMonth: string;
}

/**
 * DTO des indicators relevés
 */
export interface RelationIndicatorsMetersDto {
    city: string;
    startDate: string;
    endDate: string;
    financialYear: string;
}

/**
 * DTO des données générales par ville
 */
export interface RelationGeneralDataTableDto {
    city: string;
    countResidents: string;
    countSubscribers: string;
}

/**
 * DTO des données général
 */
export interface RelationGeneralDataDto {
    countResidents: string;
    countSubscribers: string;
}

/**
 * DTO des données générales par communes
 */
export interface RelationGeneralDataByTownDto {
    city: string;
    generalDataCount: RelationGeneralDataDto;
}
